
import Banner from './banner/Banner'
import Contact from './contact/Contact'
import HelpCard from '../help/HelpCard'
import DeliveryProcess from '../delivery/Delivery'
import Header from '../../ui/includes/Header'
import Footer from '../../ui/includes/Footer'


const Index = () => {
    return (
        <>
            <Header />
            <Banner />
            <Contact />
            <HelpCard />
            <DeliveryProcess />
            <Footer />
        </>
    )
}

export default Index
